import React from 'react';
import { Sun, Shield, Check } from 'lucide-react';

const VendorHighlights = ({ vendor, services }) => {
  const highlights = [];

  // Check if vendor has outdoor/event services
  const hasOutdoorServices = services.some(s => 
    s.service_name?.toLowerCase().includes('outdoor') ||
    s.description?.toLowerCase().includes('outdoor')
  );

  if (hasOutdoorServices || vendor?.years_experience) {
    highlights.push({
      icon: Sun,
      title: vendor?.years_experience ? `${vendor.years_experience}+ years experience` : 'Outdoor events',
      description: 'Professional service with proven track record',
    });
  }

  if (vendor?.is_verified) {
    highlights.push({
      icon: Shield,
      title: 'Verified vendor',
      description: 'Identity verified by VendorList',
    });
  }

  // Check for instant booking or quick response
  if (services.length > 0) {
    highlights.push({
      icon: Check,
      title: 'Multiple services available',
      description: `Choose from ${services.length} service options`,
    });
  }

  if (highlights.length === 0) {
    return null;
  }

  return (
    <div className="space-y-3">
      {highlights.map((highlight, index) => {
        const Icon = highlight.icon;
        const isLast = index === highlights.length - 1;
        return (
          <div key={index}>
            <div className="flex gap-3 items-start">
              <div className="flex-shrink-0 mt-0.5">
                <div className={`flex items-center justify-center ${
                  highlight.icon === Check 
                    ? 'w-5 h-5 rounded-md border border-gray-300 bg-white' 
                    : 'w-6 h-6 rounded-md bg-black'
                }`}>
                  {highlight.icon === Check ? (
                    <Icon className="w-3 h-3 text-gray-900" strokeWidth={2.5} fill="none" />
                  ) : (
                    <Icon className="w-3.5 h-3.5 text-white" strokeWidth={2} />
                  )}
                </div>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-gray-900 leading-tight">
                  {highlight.title}
                </h3>
                <p className="text-xs text-gray-500 mt-0.5 leading-snug">
                  {highlight.description}
                </p>
              </div>
            </div>
            {!isLast && (
              <div className="h-px bg-gray-100 mt-3 -mx-2" />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default VendorHighlights;

